import React from "react";
import { useTranslation } from 'react-i18next';

const NoActive = props => {
  const { t } = useTranslation( 'table_no_active' );

  return (
    <div className="noActive_container">
      {props.bloggerData.isActive === 0 ? t("wait_event") : t("wait_update")}
    </div>
  );
};

export default NoActive;
